<template>
  <div>
    <list-table
      :url="url"
      title="بستانکاران درگاه واسط"
      :fields="fields"
      :params="params"
    ></list-table>
  </div>
</template>
<script>
import TableShowData from "../../../components/table.vue";
import persianDate from "../../../helpers/persianDate";

export default {
  name: "IndirectCreditorsList",
  data() {
    return {
      url: "creditors_indirect",
      params:[],
      btns:[],
      fields: [
        {
          key: "wallet_name",
          label: "کیف پول",
        },
        {
          key: "amount",
          label: "موجودی (ریال)",
          formatter(value, key, item) {
            return Number(value).toLocaleString();
          },
        },
        {
          key: "mobile",
          label: "شماره تماس",
        },
        {
          key: "created_at",
          label: "تاریخ ایجاد",
          formatter: (value, key, item) => {
            return persianDate.getDateByFormat(value);
          },
        },
      ],
      params:[],
    };
  },
  components: {
    "list-table": TableShowData,
  },
  watch: {},
  computed: {},
  methods: {},
  mounted() {},
};
</script>